module.exports = "<div seedelement><slot></slot></div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-tagfield/theme/lui-taglist.html
// module id = 358
// module chunks = 0 1 4